import styled from '../../../node_modules/.pnpm/@linaria_react@3.0.0-beta.15_react@17.0.2/node_modules/@linaria/react/esm/styled.js';

var SuffixContainer = /*#__PURE__*/styled("div")({
  name: "SuffixContainer",
  class: "s1s4i0aj"
});

export { SuffixContainer };
